/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Feat_3_DescInputs */

const en_b2b_feat_3_desc = /** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch an authenticated community hub. Offer exclusive inventory access or post-sale support to verified buyers.`)
};

const es_b2b_feat_3_desc = /** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza un centro comunitario autenticado. Ofrece acceso a inventario exclusivo o soporte post-venta.`)
};

const fr_b2b_feat_3_desc = /** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez un centre communautaire authentifié. Offrez un accès exclusif à l'inventaire ou un support après-vente aux acheteurs vérifiés.`)
};

const de_b2b_feat_3_desc = /** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte einen authentifizierten Community-Hub. Biete verifizierten Käufern exklusiven Inventarzugang oder After-Sales-Support.`)
};

const id_b2b_feat_3_desc = /** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan pusat komunitas yang diautentikasi. Tawarkan akses inventaris eksklusif atau dukungan pasca-penjualan kepada pembeli terverifikasi.`)
};

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const ja_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const zh_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const ar_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const it_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const ru_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const pt_b2b_feat_3_desc = en_b2b_feat_3_desc;

/** @type {(inputs: B2b_Feat_3_DescInputs) => LocalizedString} */
const ko_b2b_feat_3_desc = en_b2b_feat_3_desc;

/**
* | output |
* | --- |
* | "Launch an authenticated community hub. Offer exclusive inventory access or post-sale support to verified buyers." |
*
* @param {B2b_Feat_3_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_feat_3_desc = /** @type {((inputs?: B2b_Feat_3_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Feat_3_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_feat_3_desc(inputs)
	if (locale === "es") return es_b2b_feat_3_desc(inputs)
	if (locale === "fr") return fr_b2b_feat_3_desc(inputs)
	if (locale === "de") return de_b2b_feat_3_desc(inputs)
	if (locale === "ja") return ja_b2b_feat_3_desc(inputs)
	if (locale === "zh") return zh_b2b_feat_3_desc(inputs)
	if (locale === "ar") return ar_b2b_feat_3_desc(inputs)
	if (locale === "id") return id_b2b_feat_3_desc(inputs)
	if (locale === "it") return it_b2b_feat_3_desc(inputs)
	if (locale === "ru") return ru_b2b_feat_3_desc(inputs)
	if (locale === "pt") return pt_b2b_feat_3_desc(inputs)
	return ko_b2b_feat_3_desc(inputs)
});